module.exports = __webpack_public_path__ + "img/montage-logo.e3d0c2bf.png";